<template>
  <div class="form-frame-container ">
    <div :class="computedClass" class="form-frame ">
      <b-row>
        <b-col align="right">หน้า 1/3</b-col>
      </b-row>
      <!--  เลขที่เหตุการณ์ / เลขที่ชันสูตร-->
      <b-row>
        <b-col lg="6" md="6" sm="12">
          <b-row>
            <b-col lg="3" md="5" style="padding-right: 0">เลขที่เหตุการณ์</b-col>
            <b-col lg="6" style="padding-left: 0; text-align: center">
              <input v-model="form.event_id" class="custom-input" type="text" v-on:change="updateForm('event_id')">
              <br v-if="msg_event_id">
              <div v-if="msg_event_id" class="error-message">กรุณากรอกข้อมูล</div>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="6" md="6" sm="12">
          <b-row class="justify-content-lg-end">
            <b-col lg="3" md="5" style="padding-right: 0">เลขที่ชันสูตร</b-col>
            <b-col lg="6" style="padding-left: 0; text-align: center;">
              <input v-model="form.case_id" class="custom-input" readonly="true" style="background: #F2F2F2"
                     type="text">
            </b-col>
          </b-row>
        </b-col>
        <br>
        <br>
      </b-row>

      <!-- section การอัปโหลดรูป ทั้งหมด -->
      <!-- รูปสภาพหรือชิ้นส่วนของศพที่ปรากฏ -->
      <b-row>
        <b-col lg="4" md="12" sm="12" style="padding-top: 25px;margin: auto">
          <b-col align="center" lg="12" md="12" sm="12">รูปสภาพหรือชิ้นส่วนของศพที่ปรากฏ</b-col>
          <b-col align="center" lg="12" md="12" sm="12"><p class="text-secondary" style="font-size: 12px">* ขนาดรูป ไม่เกิน 2 mb</p></b-col>
          <vue-upload-multiple-image
              :data-images="images_dead_body"
              :max-image="20"
              align="center"
              editUpload="mydeadBodyEdit"
              idUpload="mydeadBodyUpload"
              mode="deadBody"
              @upload-success="uploadImageSuccess"
              @before-remove="beforeRemove"
          >
          </vue-upload-multiple-image>
        </b-col>
      </b-row>
      <hr>
      <!--รูปบัตรประชาชน/พาสปอร์ต-->
      <b-row>
        <b-col lg="4" md="12" sm="12" style="padding-top: 25px;margin: auto">
          <b-col align="center" lg="12" md="12" sm="12">รูปบัตรประชาชน/พาสปอร์ต</b-col>
          <b-col align="center" lg="12" md="12" sm="12"><p class="text-secondary" style="font-size: 12px">* ขนาดรูป ไม่เกิน 2 mb</p></b-col>
          <vue-upload-multiple-image
              :data-images="images_card"
              :max-image="1"
              :multiple="false"
              align="center"
              center
              editUpload="myCardEdit"
              idUpload="myCardUpload"
              mode="card"
              @upload-success="uploadImageSuccess"
              @before-remove="beforeRemove"

          >
          </vue-upload-multiple-image>
        </b-col>
      </b-row>
      <hr>
      <!--รูปสถานการณ์(สถานที่ตาย)-->
      <b-row>
        <b-col lg="4" md="12" sm="12" style="padding-top: 25px;margin: auto">
          <b-col align="center" lg="12" md="12" sm="12">รูปสถานการณ์(สถานที่ตาย)</b-col>
          <b-col align="center" lg="12" md="12" sm="12"><p class="text-secondary" style="font-size: 12px">* ขนาดรูป ไม่เกิน 2 mb</p></b-col>
          <vue-upload-multiple-image
              :data-images="images_case"
              :max-image="20"
              align="center"
              editUpload="myCaseEdit"
              idUpload="myCaseUpload"
              mode="case"
              @upload-success="uploadImageSuccess"
              @before-remove="beforeRemove"
          >
          </vue-upload-multiple-image>
        </b-col>
      </b-row>
      <hr>

      <!-- section รายระเอียดเจ้าหน้าที่ -->
      <!-- 0.0 -->
      <b-row class="row" style="font-weight: normal">
        <b-col cols="12" lg="6" md="6" sm="12">
          <b-row align="left">
            <b-col lg="2" style="padding-right: 0"><b>รับแจ้ง</b></b-col>
            <b-col md="7" style="padding-left: 0">
              <div
                  style="width: 35px;height: 30px;background-color: white;position: absolute;z-index: 999;right: 16px;top:6px"></div>
              <custom-date-picker
                  :input-date="form.received_case_date"
                  :name="'received_case_date'"
                  @date-update="dateUpdate"/>
              <div v-if="err_msg_received_case_at" class="error-message">กรุณากรอกข้อมูล</div>
            </b-col>
            <b-col style="padding-left: 0">
              <b-form-input v-model="form.received_case_at"
                            type="time"
                            v-on:change="updateForm('received_case_at')">
              </b-form-input>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="6" md="6" sm="12">
          <b-row align="left">
            <b-col lg="2" style="padding-right: 0"><b>เริ่มเดินทาง</b></b-col>
            <b-col md="7" style="padding-left: 0">
              <div
                  style="width: 35px;height: 30px;background-color: white;position: absolute;z-index: 999;right: 17px;top:6px"></div>
              <custom-date-picker :input-date="form.departed_date"
                                  :name="'departed_date'"
                                  @date-update="dateUpdate"/>
              <div v-if="err_msg_departed_at" class="error-message">กรุณากรอกข้อมูลให้ถูกต้อง</div>
            </b-col>

            <b-col style="padding-left: 0">
              <b-form-input v-model="form.departed_at"
                            type="time"
                            v-on:change="updateForm('departed_at')">
              </b-form-input>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="6" md="6" sm="12">
          <b-row align="left">
            <b-col lg="2" style="padding-right: 0"><b>ถึงเวลา</b></b-col>
            <b-col md="7" style="padding-left: 0">
              <div
                  style="width: 35px;height: 30px;background-color: white;position: absolute;z-index: 999;right: 16px;top:6px"></div>
              <custom-date-picker :input-date="form.arrived_date"
                                  :name="'arrived_date'"
                                  @date-update="dateUpdate"/>
              <br v-if="msg_arrived_at">
              <div v-if="err_msg_arrived_at" class="error-message">กรุณากรอกข้อมูลให้ถูกต้อง</div>
            </b-col>
            <b-col style="padding-left: 0">
              <b-form-input v-model="form.arrived_at"
                            type="time"
                            v-on:change="updateForm('arrived_at')">
              </b-form-input>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="6" md="6" sm="12">
          <b-row align="left">

            <b-col lg="2" style="padding-right: 0"><b>เวลากลับ</b></b-col>
            <b-col md="7" style="padding-left: 0">
              <div
                  style="width: 35px;height: 30px;background-color: white;position: absolute;z-index: 999;right: 17px;top:6px"></div>
              <custom-date-picker :input-date="form.returned_date"
                                  :name="'returned_date'"
                                  @date-update="dateUpdate"/>
              <div v-if="err_msg_returned_at" class="error-message">กรุณากรอกข้อมูลให้ถูกต้อง</div>
            </b-col>
            <b-col style="padding-left: 0">
              <b-form-input v-model="form.returned_at"
                            type="time"
                            v-on:change="updateForm('returned_at')">
              </b-form-input>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- 0.1 -->
      <b-row class="row">
        <b-col cols="12" lg="6" md="6" sm="12">
          <b-row align="left">
            <b-col lg="3" style="padding-right: 0">ชื่อพนักงานสอบสวนผู้แจ้ง</b-col>
            <b-col style="padding-left: 0">
              <input v-model="form.response_officer_name" class="custom-input" type="text"
                     v-on:change="updateForm('response_officer_name')">
              <br v-if="msg_response_officer_name">
              <div v-if="msg_response_officer_name" class="error-message">กรุณากรอกข้อมูล</div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="6" md="6" sm="12">
          <b-row align="left">
            <b-col lg="3" style="padding-right: 0">สถานีตำรวจ</b-col>
            <b-col style="padding-left: 0">
              <template v-if="optionPolice">
                <multiselect v-model="form.police_station_id"
                             :options="optionPolice"
                             class="multiselect-style2"
                             deselect-label=""
                             label="name"
                             placeholder="เลือกสถานีตำรวจ"
                             select-label=""
                             selectedLabel=""
                             track-by="id"
                             @input="updateForm('police_station_id', 'id')"
                />
                <!--                        <input class="custom-input" type="text" v-model="police_station_id">-->
                <br v-if="msg_police_station_id">
                <div v-if="msg_police_station_id" class="error-message">กรุณากรอกข้อมูล</div>
              </template>
              <template v-else>
                <b-button class="email-button"
                          size="sm"
                          style="color: #2DA1A9;margin-left: 2em"
                          @click="gotoSetting()"
                >ตั้งค่าสถานีตำรวจ
                </b-button>

              </template>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- 0.2 -->
      <b-row class="row">
        <!--           เพิ่มใหม่ ไม่มีv-model-->
        <b-col cols="12" lg="6" md="6" sm="12">
          <b-row align="left">
            <b-col lg="3" style="padding-right: 0">แพทย์ชันสูตรร่วม</b-col>
            <b-col style="padding-left: 0">
<!--              <input v-model="form.doctor_name" class="custom-input" type="text"-->
<!--                     v-on:change="updateForm('doctor_name')">-->
              <template v-if="optionDoctor">
                <multiselect v-model="form.doctor_name"
                             :options="optionDoctor"
                             class="multiselect-style2"
                             deselect-label="ยกลิก"
                             label="name"
                             placeholder="เลือกแพทย์ชันสูตรร่วม"
                             select-label=""
                             selectedLabel=""
                             track-by="name"
                             @input="updateForm('doctor_name','name')"
                />
              </template>
              <br v-if="msg_doctor_name">
              <div v-if="msg_doctor_name" class="error-message">กรุณากรอกข้อมูล</div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="6" md="6" sm="12">
          <b-row align="left">
            <b-col lg="3" style="padding-right: 0">เหตุที่แจ้งเบื้องต้น</b-col>
            <b-col style="padding-left: 0">
              <!--                        optionCircumstances-->
              <multiselect v-model="form.circumstances_id"
                           :options="optionCircumstances"
                           class="multiselect-style2"
                           deselect-label=""
                           label="name"
                           placeholder="เลือกพฤติการณ์ที่ตาย"
                           select-label=""
                           selectedLabel=""
                           track-by="name"
                           @input="updateForm('circumstances_id','id')"
              />
              <!--                        <input class="custom-input" type="text" v-model="circumstances_id">-->
              <br v-if="msg_death_reason_addition">
              <div v-if="msg_death_reason_addition" class="error-message">กรุณากรอกข้อมูล</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!--เวลาเสียชีวิต-->
      <b-row class="row col-12 text-left ">
        <b-col class="text-left" cols="12" lg="12">
          <b-form-checkbox-group id="radio-group-1" v-model="timeOfdead">
            <b-col cols="12" sm="12">
              <b-row class="row">
                <b-col class="ml-0 pl-0" cols="12" lg="12" md="10" sm="12">
                  <b-row align="left" class="pl-0 ml-0">
                    <p class="mr-3">วัน-เวลาที่เสียชีวิต</p>
                    <b-col lg="2" md="4" style="padding-left: 0">
                      <custom-date-picker :input-date="form.dead_date" :disabled="timeOfdead" id="dead_date" :name="'dead_date'" @date-update="dateUpdate"/>
                    </b-col>
                    <b-col lg="2" md="4" style="padding-left: 0;">
                      <b-form-input v-model="form.dead_time" :disabled="timeOfdead" type="time" id="dead_time"
                                    v-on:change="updateForm('dead_time')"></b-form-input>
                    </b-col>
                    <b-col lg="1" md="4" style="padding-left: 0">
                      <label class="radio-label">
                        <b-form-checkbox class="radio-135">
                          ไม่ทราบข้อมูล
                        </b-form-checkbox>
                      </label>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <br/>
            </b-col>
          </b-form-checkbox-group>
        </b-col>
      </b-row>
      <b-row v-if="timeOfdead" class="pl-3 ml-3 mt-0 pt-0">
        <b-col cols="12" lg="6" md="6" sm="12" style="padding-left: 0"><u>โปรดกรอกข้อมูลเวลาก่อนทำการชันสูตร</u>
          <span v-if="msg_timeOfdead" class="error-message" style="font-size: 18px;padding-left: 3px">กรุณากรอกข้อมูล</span>
        </b-col>
        <b-col class="my-2" lg="12" style="padding-left: 0;">
          <b-row>
            <b-col lg="3">
              <b-row>
                <b-col cols="12" lg="2">วัน</b-col>
                <b-col><input v-model="form.day_before_identify" class="custom-input" type="number"
                              v-on:change="updateForm('day_before_identify')"></b-col>
              </b-row>


            </b-col>
            <b-col lg="3">
              <b-row>
                <b-col cols="12" lg="2">ชั่วโมง</b-col>
                <b-col><input v-model="form.hours_before_identify" class="custom-input" type="number"
                              v-on:change="updateForm('hours_before_identify')"></b-col>
              </b-row>

            </b-col>
            <b-col cols="12" lg="3">
              <b-row>
                <b-col lg="2">นาที</b-col>
                <b-col><input v-model="form.minutes_before_identify" class="custom-input" type="number"
                              v-on:change="updateForm('minutes_before_identify')"></b-col>
              </b-row>

            </b-col>
          </b-row>

          <!--          <b-form-input type="time" v-on:change="updateForm('time_before_identify')" v-model="form.time_before_identify"></b-form-input>-->
        </b-col>
      </b-row>
      <hr>

      <!--ข้อมูลผู้เสียชีวิต-->
      <!-- 1 -->
      <b-row class="row">
        <b-col cols="12">
          <b-row>
            <b-form-checkbox-group id="radio-group-1" v-model="checkedName">
              <b-col cols="12" sm="12">
                ข้อมูลผู้เสียชีวิต
                <label class="radio-label">
                  <b-form-checkbox id="unknownName" class="radio-135"
                                   @change="checkedUnknownInfomationOfDead('unknown_dead_name')">
                    ไม่ทราบข้อมูลบุคคล
                  </b-form-checkbox>
                </label>
              </b-col>
            </b-form-checkbox-group>
            <template v-if="checkedName">
              <div class="my-2 ml-4">
                <u>โปรดกรอกข้อมูลเบื้องต้น (อายุโดยประมาณ และเพศ)</u>
              </div>
            </template>
          </b-row>

        </b-col>
      </b-row>
      <b-row class="row">
        <b-col class="pr-0" cols="12" lg="12" md="12" sm="12">
          <b-row align="left">
            <b-col lg="6" md="6" sm="12">
              <b-row align="left" class="pt-0">
                <b-col lg="3" md="12" style="padding-left: 0;">1. ชื่อจริง</b-col>
                <b-col lg="9" md="12" style="padding-left: 0">
                  <input v-if="checkedName == true" :disabled="checkedName" class="custom-input disabled">
                  <input v-else v-model="form.dead_firstname" :disabled="checkedName" class="custom-input"
                         type="text" v-on:change="updateForm('dead_firstname')">
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="6" md="6" sm="12">
              <b-row align="left" class="pt-0">

                <b-col lg="3" md="12" style="padding-left: 0;">นามสกุล</b-col>
                <b-col lg="9" md="12" style="padding-left: 0">
                  <input v-if="checkedName == true" :disabled="checkedName" class="custom-input disabled">
                  <input v-else v-model="form.dead_lastname" :disabled="checkedName" class="custom-input"
                         type="text" v-on:change="updateForm('dead_lastname')">
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="12">
          <br>
        </b-col>
      </b-row>
      <b-row class="row">
        <b-col class="pr-0" cols="12" lg="12" md="12" sm="12">
          <b-row align="left">
            <b-col lg="4" md="6" sm="12">
              <b-row align="left" class="pt-0">
                <b-col lg="4" md="12" style="padding-left: 0;">วัน/เดือน/ปี เกิด</b-col>
                <b-col lg="8" md="12" style="padding-left: 0">
                  <input v-if="checkedName == true" :disabled="checkedName" class="custom-input disabled">
                  <custom-date-picker v-else
                                      id="birthDate"
                                      :input-date="form.birthDate"
                                      :name="'birthDate'"
                                      @date-update="dateUpdate"/>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="2" md="6" sm="12">
              <b-row align="left" class="pt-0">
                <b-col lg="3" md="12" style="padding-left: 0;">อายุ</b-col>
                <b-col lg="9" md="12" style="padding-left: 0">
                  <b-form-input id="dead_age"
                                v-model="form.dead_age" max="150"
                                maxlength="3"
                                min="0" type="number" v-on:change="updateForm('dead_age')">
                  </b-form-input>
                  <br v-if="msg_dead_age">
                  <div v-if="msg_dead_age" class="error-message">กรุณากรอกข้อมูลให้ถูกต้อง</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="6" md="6" sm="12">
              <b-row align="left" class="pt-0">

                <b-col lg="1" md="1" sm="12" style="padding-left: 0;">เพศ</b-col>
                <b-col class="col-xs-12" lg="11" md="11" sm="12" style="padding-left: 0;">
                  <b-form-radio-group id="radio-group-1" v-model="form.dead_gender" name="sex"
                                      @input="updateForm('dead_gender')">
                    <label class="radio-label" size="sm">
                      <b-form-radio class="radio-135" size="sm" value="ชาย"><b>ชาย</b></b-form-radio>
                    </label>
                    <label class="radio-label" size="sm">
                      <b-form-radio class="radio-135" size="sm" value="หญิง"><b>หญิง</b></b-form-radio>
                    </label>
                    <label class="radio-label" size="sm">
                      <b-form-radio class="radio-135 " size="sm" value="ไม่สามารถระบุเพศ"><b>ไม่สามารถระบุเพศ</b>
                      </b-form-radio>
                    </label>
                  </b-form-radio-group>
                </b-col>

              </b-row>
            </b-col>
          </b-row>
        </b-col>

      </b-row>

      <!--2 เลขประจำตัวประชาชน-->
      <b-row class="row">
        <br>
        <b-row class="row">
          <b-col class="pr-0" cols="12" lg="12" md="12" sm="12">
            <b-row align="left">
              <b-col lg="8" md="6" sm="12">
                <b-row align="left" class="pt-0">
                  <b-col lg="4" md="12" style="padding-left: 0;">2. เลขประจำตัวประชาชน</b-col>
                  <b-col lg="8" md="12" style="padding-left: 0">
                    <input v-if="checkedName == true" :disabled="checkedName" class="custom-input disabled">
                    <input v-else v-model="form.dead_id"
                           class="custom-input"
                           maxlength="13"
                           type="text"
                           @input="checkCitizenIDformat">
                    <div class="error-message">{{ msg_dead_id }}</div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col lg="4" md="6" sm="12">
                <b-row align="left" class="pt-0">
                  <b-col lg="4" md="12" style="padding-left: 0;">สัญชาติ</b-col>
                  <b-col lg="8" md="12" style="padding-left: 0">
                    <input v-if="checkedName == true" :disabled="checkedName" class="custom-input disabled">
                    <input v-else v-model="form.dead_nationality" class="custom-input" type="text"
                           v-on:change="updateForm('dead_nationality')">
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="12">
            <br>
          </b-col>
        </b-row>
      </b-row>
      <hr>
      <!--3 ที่อยู่ผู้เสียชีวิต-->
      <b-row class="row">
        <b-col cols="12" lg="12" md="12" sm="12">
          <b-col align="left" lg="8" style="padding-top: 0.5rem;padding-bottom: 0.5rem;padding-left: 0" xl="8">
            <b-col cols="12" sm="12">
              3. ที่อยู่ผู้เสียชีวิต
            </b-col>
          </b-col>
        </b-col>
      </b-row>
      <template v-if="checkedCurrentAddressKnown === 'true'">
        <!--ที่อยู่ตามบัตรประชาชน-->
        <b-col cols="12" lg="12" md="12" sm="12">
          <b-col align="left" lg="12" style="padding-top: 0.5rem;padding-bottom: 0.5rem;">3.1 ที่อยู่ตามบัตรประชาชน
            <label class="radio-label">
              <b-form-checkbox id="unknownAddressIDcard" v-model="checkedAddressIDcard"
                               class="radio-135"
                               @change="checkedUnknownInfomationOfDead('unknown_dead_address_id')">ไม่ทราบข้อมูล
              </b-form-checkbox>
            </label>
          </b-col>
          <b-row align="left" style="font-weight: normal">
            <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">ที่อยู่</b-col>
            <b-col lg="9" md="12" style="padding-left: 0; padding-bottom: 0.5rem">
              <input v-if="checkedAddressIDcard == true" :disabled="checkedAddressIDcard" class="custom-input disabled">
              <input v-else v-model="form.dead_place_address_idCard" :disabled="checkedAddressIDcard"
                     class="custom-input" type="text"
                     v-on:change="updateForm('dead_place_address_idCard')">
              <br v-if="msg_address">
              <div v-if="msg_address" class="error-message">กรุณากรอกข้อมูล</div>
            </b-col>
          </b-row>
          <b-row align="left" style="font-weight: normal">
            <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">บ้านเลขที่</b-col>
            <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
              <input v-if="checkedAddressIDcard == true" :disabled="checkedAddressIDcard" class="custom-input disabled">
              <input v-else v-model="form.dead_address_idCard" :disabled="checkedAddressIDcard"
                     class="custom-input" type="text" v-on:change="updateForm('dead_address_idCard')">
              <br v-if="msg_address">
              <div v-if="msg_address" class="error-message">กรุณากรอกข้อมูล</div>
            </b-col>
            <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">หมู่</b-col>
            <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
              <input v-if="checkedAddressIDcard == true" :disabled="checkedAddressIDcard" class="custom-input disabled">
              <input v-else v-model="form.address_village_no_idCard" :disabled="checkedAddressIDcard"
                     class="custom-input" type="text" v-on:change="updateForm('address_village_no_idCard')">
              <br v-if="msg_address_village_no">
              <div v-if="msg_address_village_no" class="error-message">กรุณากรอกข้อมูล</div>

            </b-col>
            <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">ตรอก/ซอย</b-col>
            <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
              <input v-if="checkedAddressIDcard == true" :disabled="checkedAddressIDcard" class="custom-input disabled">
              <input v-else v-model="form.address_street_idCard" :disabled="checkedAddressIDcard"
                     class="custom-input" type="text" v-on:change="updateForm('address_street_idCard')">
              <br v-if="msg_address_street">
              <div v-if="msg_address_street" class="error-message">กรุณากรอกข้อมูล</div>
            </b-col>
            <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">ถนน</b-col>
            <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
              <input v-if="checkedAddressIDcard == true" :disabled="checkedAddressIDcard" class="custom-input disabled">
              <input v-else v-model="form.address_road_idCard" :disabled="checkedAddressIDcard"
                     class="custom-input" type="text" v-on:change="updateForm('address_road_idCard')">
              <br v-if="msg_address_road">
              <div v-if="msg_address_road" class="error-message">กรุณากรอกข้อมูล</div>
            </b-col>
          </b-row>
        </b-col>
        <b-row class="row">
          <b-col cols="12" lg="12" md="12" sm="12">
            <b-row align="left" style="font-weight: normal;">
              <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">จังหวัด
                <br v-if="msg_address_province_id" :disabled="!checkedAddressIDcard">
              </b-col>
              <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
                <multiselect v-model="form.address_province_id_idCard"
                             :disabled="checkedAddressIDcard"
                             :options="optionProvincedie"
                             class="multiselect-style2"
                             deselect-label=""
                             label="name"
                             placeholder="เลือกจังหวัด"
                             select-label=""
                             selectedLabel=""
                             track-by="name"
                             @input="getAddressDistricts_Card(form.address_province_id_idCard, true)"
                />
                <div v-if="msg_address_province_id" class="error-message">กรุณาเลือกจังหวัด</div>
              </b-col>
              <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">อำเภอ</b-col>
              <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
                <multiselect v-model="form.address_district_id_idCard"
                             :disabled="form.address_province_id_idCard === null || checkedAddressIDcard"
                             :options="{SwitchData} ? (optionDistrictdie):(AllDistricts)"
                             class="multiselect-style2"
                             deselect-label=""
                             label="name"
                             placeholder="เลือกอำเภอ"
                             select-label=""
                             selectedLabel=""
                             track-by="name"
                             @input="getAddresSubDistricts_Card(form.address_district_id_idCard, true)"
                />
                <div v-if="msg_address_district_id" class="error-message">กรุณาเลือกอำเภอ</div>
              </b-col>
              <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">ตำบล</b-col>
              <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
                <multiselect v-model="form.address_sub_district_id_idCard"
                             :disabled="form.address_district_id_idCard === null || checkedAddressIDcard"
                             :options="{SwitchData} ? (optionSubDistrictdie):(AllSubdistricts)"
                             class="multiselect-style2"
                             deselect-label=""
                             label="name"
                             placeholder="เลือกตำบล"
                             select-label=""
                             selectedLabel=""
                             track-by="name"
                             @input="updateForm('address_sub_district_id_idCard','subdistrict_id')"
                             @select="updateForm('address_sub_district_id_idCard','subdistrict_id')"

                />
                <div v-if="msg_address_sub_district_id" class="error-message">กรุณาเลือกตำบล</div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!--ที่อยู่ปัจจุบัน -->
        <b-row class="row">
          <b-col cols="12" lg="12" md="12" sm="12">
            <b-col align="left" lg="12" style="padding-top: 0.5rem;padding-bottom: 0.5rem;">3.2 ที่อยู่ปัจจุบัน
              <label class="radio-label">
                <b-form-checkbox id="setAddressFollowupIDCard" v-model="checkedAddressFollowupIdCard"
                                 :disabled="this.checkedAddressIDcard || !this.dead_address_in_IDCard" class="radio-135"
                                 @change="setAddressFollowupIDcard()">ข้อมูลตามบัตรประชนชน
                </b-form-checkbox>
              </label>
              <label class="radio-label">
                <b-form-checkbox id="unknownCurrentAddress" v-model="checkedCurrentAddress"
                                 class="radio-135"
                                 @change="checkedUnknownInfomationOfDead('unknown_dead_address')">ไม่ทราบข้อมูล
                </b-form-checkbox>
              </label>
            </b-col>
            <b-row align="left" style="font-weight: normal">
              <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">ที่อยู่</b-col>
              <b-col lg="9" md="12" style="padding-left: 0; padding-bottom: 0.5rem">
                <input v-if="checkedCurrentAddress == true" :disabled="checkedCurrentAddress"
                       class="custom-input disabled">
                <input v-else v-model="form.dead_place_address" :disabled="checkedCurrentAddress"
                       class="custom-input" type="text" v-on:change="updateForm('dead_place_address')">
              </b-col>
            </b-row>
            <b-row align="left" style="font-weight: normal">
              <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">บ้านเลขที่</b-col>
              <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
                <input v-if="checkedCurrentAddress == true" :disabled="checkedCurrentAddress"
                       class="custom-input disabled">
                <input v-else v-model="form.address" :disabled="checkedCurrentAddress" class="custom-input"
                       type="text" v-on:change="updateForm('address')">
                <br v-if="msg_address">
                <div v-if="msg_address" class="error-message">กรุณากรอกข้อมูล</div>
              </b-col>
              <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">หมู่</b-col>
              <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
                <input v-if="checkedCurrentAddress == true" :disabled="checkedCurrentAddress"
                       class="custom-input disabled">
                <input v-else v-model="form.address_village_no" :disabled="checkedCurrentAddress"
                       class="custom-input" type="text" v-on:change="updateForm('address_village_no')">
                <br v-if="msg_address_village_no">
                <div v-if="msg_address_village_no" class="error-message">กรุณากรอกข้อมูล</div>

              </b-col>
              <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">ตรอก/ซอย</b-col>
              <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
                <input v-if="checkedCurrentAddress == true" :disabled="checkedCurrentAddress"
                       class="custom-input disabled">
                <input v-else v-model="form.address_street" :disabled="checkedCurrentAddress"
                       class="custom-input" type="text" v-on:change="updateForm('address_street')">
                <br v-if="msg_address_street">
                <div v-if="msg_address_street" class="error-message">กรุณากรอกข้อมูล</div>
              </b-col>
              <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">ถนน</b-col>
              <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
                <input v-if="checkedCurrentAddress == true" :disabled="checkedCurrentAddress"
                       class="custom-input disabled">
                <input v-else v-model="form.address_road" :disabled="checkedCurrentAddress"
                       class="custom-input" type="text" v-on:change="updateForm('address_road')">
                <br v-if="msg_address_road">
                <div v-if="msg_address_road" class="error-message">กรุณากรอกข้อมูล</div>
              </b-col>
            </b-row>

          </b-col>
        </b-row>
        <b-row class="row">
          <b-col cols="12" lg="12" md="12" sm="12">
            <b-row align="left" style="font-weight: normal;">
              <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">จังหวัด
                <br v-if="msg_address_province_id" :disabled="!checkedCurrentAddress">
              </b-col>
              <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
                <multiselect v-model="form.address_province_id"
                             :disabled="checkedCurrentAddress"
                             :options="optionProvincedie"
                             class="multiselect-style2"
                             deselect-label=""
                             label="name"
                             placeholder="เลือกจังหวัด"
                             select-label=""
                             selectedLabel=""
                             track-by="name"
                             @input="getAddressDistricts(form.address_province_id, true)"
                />
                <div v-if="msg_address_province_id" class="error-message">กรุณาเลือกจังหวัด</div>
              </b-col>
              <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">อำเภอ</b-col>
              <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
                <multiselect v-model="form.address_district_id"
                             :disabled="form.address_province_id === null || checkedCurrentAddress"
                             :options="{SwitchData} ? (optionDistrictdie):(AllDistricts)"
                             class="multiselect-style2"
                             deselect-label=""
                             label="name"
                             placeholder="เลือกอำเภอ"
                             select-label=""
                             selectedLabel=""
                             track-by="name"
                             @input="getAddresSubDistricts(form.address_district_id, true)"
                />
                <div v-if="msg_address_district_id" class="error-message">กรุณาเลือกอำเภอ</div>
              </b-col>
              <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">ตำบล</b-col>
              <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
                <multiselect v-model="form.address_sub_district_id"
                             :disabled="form.address_district_id === null || checkedCurrentAddress"
                             :options="{SwitchData} ? (optionSubDistrictdie):(AllSubdistricts)"
                             class="multiselect-style2"
                             deselect-label=""
                             label="name"
                             placeholder="เลือกตำบล"
                             select-label=""
                             selectedLabel=""
                             track-by="name"
                             @input="updateForm('address_sub_district_id','subdistrict_id')"
                             @select="updateForm('address_sub_district_id','subdistrict_id')"

                />
                <div v-if="msg_address_sub_district_id" class="error-message">กรุณาเลือกตำบล</div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>


      </template>
      <hr>

      <!--4 สถานที่พบศพ-->
      <b-row style="padding: 0">
        <b-col cols="12" lg="12" md="12" sm="12">
          <b-col align="left" lg="12" style="padding: 0.5rem 2rem">4. สถานที่พบศพ</b-col>
          <!--        Map -->
          <div id="google-form" class="form-div">
            <!-- สร้าแผนที่และกำหนดคุณสมบัติ -->
            <!--            :placeholder="form.location"-->
            <div class="row">
              <b-button class="email-button"
                        size="sm"
                        style="color: #2DA1A9;margin-left: 2em"
                        @click="geolocation"
              >ที่ตั้งปัจจุบัน
              </b-button>
              <br>
              <div class="col-sm-12 col-lg-9 col-md-8 mt-1">
                <gmap-autocomplete
                    id="searchLocation"
                    :placeholder="form.location"
                    class="custom-input"
                    @place_changed="setPlace"

                >
                </gmap-autocomplete>
                <div v-if="msg_location" class="error-message">กรุณากรอกข้อมูล</div>
              </div>
            </div>
            <br>
            <gmap-map :center="this.center"
                      :zoom="15"
                      class="google-map"
                      @click="setPlaceFromGoogleData">

              <gmap-marker
                  v-for="(m, index) in this.markers"
                  :key="index"
                  :position="m.position"
                  @click="center=m.position">
              </gmap-marker>
            </gmap-map>
            <br>
          </div>

          <b-row align="left" class="row" style="font-weight: normal;padding: 0 2rem">
            <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">สถานที่ตาย</b-col>
            <b-col lg="9" md="12" style="padding-left: 0; padding-bottom: 0.5rem">
              <input v-model="form.dead_place_at" class="custom-input" type="text"
                     v-on:change="updateForm('dead_place_at')">
              <!--              <br v-if="msg_village_no">-->
              <!--              <div class="error-message" v-if="msg_village_no">กรุณากรอกข้อมูล</div>-->
            </b-col>
          </b-row>

          <b-row align="left" class="row" style="font-weight: normal;padding: 0 2rem">

            <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">หมู่</b-col>
            <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
              <input v-model="form.village_no" class="custom-input" type="text" v-on:change="updateForm('village_no')">
              <br v-if="msg_village_no">
              <div v-if="msg_village_no" class="error-message">กรุณากรอกข้อมูล</div>
            </b-col>

            <!--                    ยังไมไ่ด้เก็บค่า-->
            <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">จังหวัด</b-col>
            <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
              <multiselect id="location_province_id"
                           v-model="form.location_province_id"
                           :options="optionProvince"
                           class="multiselect-style2"
                           deselect-label=""
                           label="name"
                           placeholder="เลือกจังหวัด"
                           select-label=""
                           selectedLabel=""
                           track-by="name"
                           @input="getDistricts(form.location_province_id, 'location_province_id')"
                           @select="updateForm( 'location_province_id', 'code')"
              />
              <div v-if="msg_location_province_id" class="error-message">กรุณาเลือกจังหวัด</div>
            </b-col>
            <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">อำเภอ</b-col>
            <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
              <multiselect id="location_district_id"
                           v-model="form.location_district_id"
                           :disabled="form.location_province_id === null"
                           :options="{SwitchData} ? (optionDistrict):(AllDistricts)"
                           class="multiselect-style2"
                           deselect-label=""
                           label="name"
                           placeholder="เลือกอำเภอ"
                           select-label=""
                           selectedLabel=""
                           track-by="name"
                           @input="getSubDistricts(form.location_district_id, 'location_district_id')"
                           @select="updateForm( 'location_district_id', 'district_id')"
              />
              <div v-if="msg_location_district_id" style="color: red;font-size: 10px;width: 100%;text-align: center;">
                กรุณาเลือกอำเภอ
              </div>
            </b-col>
            <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">ตำบล</b-col>
            <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
              <multiselect id="location_sub_district_id"
                           v-model="form.location_sub_district_id"
                           :disabled="form.location_district_id === null"
                           :options="{SwitchData} ? (optionSubDistrict):(AllSubdistricts)"
                           class="multiselect-style2"
                           deselect-label=""
                           label="name"
                           placeholder="เลือกตำบล"
                           select-label=""
                           selectedLabel=""
                           track-by="name"
                           @input="updateForm('location_sub_district_id', 'subdistrict_id')"
                           @select="updateForm( 'location_sub_district_id', 'subdistrict_id')"

              />
              <div v-if="msg_location_sub_district_id" class="error-message">กรุณาเลือกตำบล</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row style="padding: 0">
        <b-col cols="12" lg="12" md="12" sm="12">
          <!--                    ยังไมไ่ด้เก็บค่า-->
          <b-row align="left" class="row" style="font-weight: normal;padding: 0 2rem">
            <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">ละติจูด</b-col>
            <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
              <input v-model="form.lat" class="custom-input" type="text" v-on:change="updateForm('lat')">
              <!--                            <br v-if="msg_lat">-->
              <!--                            <div class="error-message" v-if="msg_lat">กรุณากรอกข้อมูล</div>-->
            </b-col>
            <b-col lg="1" md="2" style="padding-right: 0; padding-bottom: 0.5rem">ลองติจูด</b-col>
            <b-col lg="2" md="4" style="padding-left: 0; padding-bottom: 0.5rem">
              <input v-model="form.lon" class="custom-input" type="text" v-on:change="updateForm('lon')">
              <!--                            <br v-if="msg_lng">-->
              <!--                            <div class="error-message" v-if="msg_lng">กรุณากรอกข้อมูล</div>-->
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr>

      <!--5 ลักษณะของสถานที่ที่พบศพนั้นอยู่-->
      <b-row class="row">
        <b-col cols="12" lg="12" md="12" sm="12">
          <b-row align="left">
            <b-col lg="12" style="padding-right: 0">5. ลักษณะของสถานที่ที่พบศพนั้นอยู่</b-col>
            <b-col class="mt-3">
              <b-form-textarea id="textarea"
                               v-model="form.location_style"
                               class="custom-input"
                               max-rows="6"
                               rows="3"
                               style="overflow-y: unset"
                               v-on:change="updateForm('location_style')"
              ></b-form-textarea>
              <div v-if="msg_location_style" class="error-message">กรุณากรอกข้อมูล</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr>

      <!--6 ประวัติโดยสังเขป-->
      <b-row class="row">
        <b-col cols="12" lg="12" md="12" sm="12">
          <b-row align="left">
            <b-col lg="12" style="padding-right: 0">6. ประวัติโดยสังเขป</b-col>
            <b-col class="mt-3">
              <b-form-textarea id="textarea"
                               v-model="form.short_history"
                               class="custom-input"
                               max-rows="6"
                               rows="3"
                               style="overflow-y: unset"
                               v-on:change="updateForm('short_history')"
              ></b-form-textarea>
              <div v-if="msg_short_history" class="error-message">กรุณากรอกข้อมูล</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr>

      <!--7 วันเวลาที่มีผู้พบศพ-->
      <b-row class="row">
        <b-col cols="12" lg="7" md="10" sm="12">
          <b-row align="left">
            <b-col class="pr-0" lg="4" md="4">7. วันเวลาที่มีผู้พบศพ</b-col>
            <b-col class="pl-0" lg="5" md="4">
              <custom-date-picker :input-date="form.found_date" :name="'found_date'" @date-update="dateUpdate"/>
              <br v-if="msg_found_date">
              <div v-if="msg_found_date" class="error-message">กรุณาเลือกวันที่</div>
            </b-col>
            <b-col style="padding-left: 0;">
              <b-form-input v-model="form.found_at" type="time" v-on:change="updateForm('found_at')"></b-form-input>
              <div v-if="msg_found_at" class="error-message">กรุณากรอกข้อมูลให้ถูกต้อง</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row align="left">
        <b-col cols="12" lg="7" md="10" sm="12">
          <b-row align="left">
            <b-col class="pr-0" lg="4" md="4">ชื่อผู้แจ้งพบศพ (ถ้าทราบ)</b-col>
            <b-col class="pl-0" lg="5" md="4">
              <input v-model="form.found_name" class="custom-input" type="text" v-on:change="updateForm('found_name')">
              <div v-if="msg_found_name"
                   style="color: red;font-size: 10px;font-weight: normal;width: 100%;text-align: center">กรุณากรอกข้อมูล
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr>

      <!--8 วันเวลาที่มีผู้พบว่ามีชีวิตอยู่เป็นครั้งสุดท้าย-->
      <b-row class="row">
        <b-col cols="12" lg="7" md="10" sm="12">
          <b-row align="left">
            <b-col lg="4" md="4" style="padding-right: 0">8. วันเวลาที่มีผู้พบว่ามีชีวิตอยู่เป็นครั้งสุดท้าย</b-col>
            <b-col lg="5" md="4" style="padding-left: 0">
              <!--              <b-form-input type="date" v-model="form.last_found_date" v-on:change="updateForm('last_found_date')"></b-form-input>-->
              <custom-date-picker :input-date="form.last_found_date" :disabled="last_found_date" :name="'last_found_date'"
                                  @date-update="dateUpdate"/>
              <label class="radio-label">
                <b-form-checkbox class="radio-135" v-model="last_found_date">
                  ไม่ทราบข้อมูล
                </b-form-checkbox>
              </label>
              <br v-if="msg_last_found_date">
              <div v-if="msg_last_found_date && !last_found_date" class="error-message">กรุณากรอกข้อมูลให้ถูกต้อง</div>
            </b-col>
            <b-col style="padding-left: 0;">
              <b-form-input v-model="form.last_found_at" type="time"
                            :disabled="last_found_date"
                            v-on:change="updateForm('last_found_at')"></b-form-input>
              <div v-if="msg_last_found_at" class="error-message">กรุณากรอกข้อมูล</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr>

      <!--9 ประวัติการรักษา/โรคประจำตัว-->
      <b-col cols="12" lg="12" md="12" sm="12">
        <b-row align="left">
          <b-form-radio-group id="radio-group-1" v-model="checkedMedicalHistory">
            <b-col cols="12" sm="12">
              9. ประวัติการรักษา/โรคประจำตัว
              <label class="radio-label">
                <b-form-radio class="radio-135" value="false">ไม่มี</b-form-radio>
              </label>
              <label class="radio-label">
                <b-form-radio class="radio-135" value="true">มี(โปรดระบุ)</b-form-radio>
              </label>
            </b-col>
          </b-form-radio-group>
          <b-col lg="12" style="padding-right: 0">
            <b-col v-if="checkedMedicalHistory === 'true'" class="mt-3">
              <b-form-textarea id="textarea"
                               v-model="form.treat_history"
                               class="custom-input"
                               max-rows="6"
                               rows="3"
                               style="overflow-y: unset"
                               v-on:change="updateForm('treat_history')"
              ></b-form-textarea>
            </b-col>
          </b-col>
        </b-row>
      </b-col>

      <hr>
      <!--10 สาเหตุการตาย -->
      <b-row class="row">
        <b-col cols="12" lg="12" md="12" sm="12">
          <b-row align="left">
            <!--  TODO add more option; max 4 option    -->

            <b-col lg="2" md="3">สาเหตุการตายที่ 1</b-col>
            <b-col lg="7" md="6" style="padding-left: 0; padding-bottom: 0.5rem">
                <multiselect v-model="form.death_reason_id1"
                             :options="optionDeathreason"
                             class="multiselect-style2"
                             deselect-label=""
                             label="name"
                             placeholder="เลือกสาเหตุการตาย"
                             select-label=""
                             selectedLabel=""
                             track-by="id"
                             @input="updateForm('death_reason_id1','id')"
                />
                <div v-if="msg_death_reason_id" class="error-message">กรุณาเลือกสาเหตุการตาย</div>
            </b-col>
            <b-col lg="3" md="3" style="padding-left: 0; padding-bottom: 0.5rem">
              <input v-model="form.ICD_No1" placeholder="ICD" maxlength="6" class="custom-input" type="text" v-on:change="updateForm('ICD_No1')">
            </b-col>

            <b-col lg="2" md="3">สาเหตุการตายที่ 2</b-col>
            <b-col lg="7" md="6" style="padding-left: 0; padding-bottom: 0.5rem">
              <multiselect v-model="form.death_reason_id2"
                           :options="optionDeathreason"
                           class="multiselect-style2"
                           deselect-label=""
                           label="name"
                           placeholder="เลือกสาเหตุการตาย"
                           select-label=""
                           selectedLabel=""
                           track-by="id"
                           @input="updateForm('death_reason_id2','id')"
              />
              <div v-if="msg_death_reason_id" class="error-message">กรุณาเลือกสาเหตุการตาย</div>
            </b-col>
            <b-col lg="3" md="3" style="padding-left: 0; padding-bottom: 0.5rem">
              <input v-model="form.ICD_No2" placeholder="ICD" maxlength="6" class="custom-input" type="text" v-on:change="updateForm('ICD_No2')">
            </b-col>
            <b-col lg="2" md="3">สาเหตุการตายที่ 3</b-col>
            <b-col lg="7" md="6" style="padding-left: 0; padding-bottom: 0.5rem">
              <multiselect v-model="form.death_reason_id3"
                           :options="optionDeathreason"
                           class="multiselect-style2"
                           deselect-label=""
                           label="name"
                           placeholder="เลือกสาเหตุการตาย"
                           select-label=""
                           selectedLabel=""
                           track-by="id"
                           @input="updateForm('death_reason_id3','id')"
              />
              <div v-if="msg_death_reason_id" class="error-message">กรุณาเลือกสาเหตุการตาย</div>
            </b-col>
            <b-col lg="3" md="3" style="padding-left: 0; padding-bottom: 0.5rem">
              <b-form-input v-model="form.ICD_No3" placeholder="ICD" maxlength="6" class="custom-input" type="text" v-on:change="updateForm('ICD_No3')"></b-form-input>
            </b-col>

            <b-col lg="2" md="3">สาเหตุการตายที่ 4</b-col>
            <b-col lg="7" md="6" style="padding-left: 0; padding-bottom: 0.5rem">
              <multiselect v-model="form.death_reason_id4"
                           :options="optionDeathreason"
                           class="multiselect-style2"
                           deselect-label=""
                           label="name"
                           placeholder="เลือกสาเหตุการตาย"
                           select-label=""
                           selectedLabel=""
                           track-by="id"
                           @input="updateForm('death_reason_id4','id')"
              />
              <div v-if="msg_death_reason_id" class="error-message">กรุณาเลือกสาเหตุการตาย</div>
            </b-col>
            <b-col lg="3" md="3" style="padding-left: 0; padding-bottom: 0.5rem">
              <b-form-input v-model="form.ICD_No4" placeholder="ICD" maxlength="6" class="custom-input" type="text"  v-on:change="updateForm('ICD_No4')"></b-form-input>
            </b-col>

            <b-col lg="2" md="3">สาเหตุการตายอื่นๆ</b-col>
            <b-col lg="10" md="9" style="padding-left: 0; padding-bottom: 0.5rem">
              <b-form-textarea id="textarea"
                               v-model="form.death_reason_other"
                               class="custom-input"
                               max-rows="6"
                               rows="3"
                               style="overflow-y: unset"
                               v-on:change="updateForm('death_reason_other')"
              >
              </b-form-textarea>
            </b-col>
            <br>
          </b-row>
          <b-row align="left" class="mt-3">
            <!--  TODO add more option; max 5 option    -->

            <b-col lg="2" md="3">พฤติการณ์ที่ตาย 1</b-col>
            <b-col lg="10" md="9" style="padding-left: 0; padding-bottom: 0.5rem">
              <multiselect v-model="form.death_reason_addition1"
                           :options="optionCircumstances"
                           class="multiselect-style2"
                           deselect-label=""
                           label="name"
                           placeholder="เลือกพฤติการณ์ที่ตาย"
                           select-label=""
                           selectedLabel=""
                           track-by="id"
                           @input="updateForm('death_reason_addition1','id')"
              />
              <div v-if="msg_circumstances_id" class="error-message">กรุณาเลือกพฤติการณ์ที่ตาย</div>
            </b-col>

            <b-col lg="2" md="3">พฤติการณ์ที่ตาย 2</b-col>
            <b-col lg="10" md="9" style="padding-left: 0; padding-bottom: 0.5rem">
              <multiselect v-model="form.death_reason_addition2"
                           :options="optionCircumstances"
                           class="multiselect-style2"
                           deselect-label=""
                           label="name"
                           placeholder="เลือกพฤติการณ์ที่ตาย"
                           select-label=""
                           selectedLabel=""
                           track-by="id"
                           @input="updateForm('death_reason_addition2','id')"
              />
              <div v-if="msg_circumstances_id" class="error-message">กรุณาเลือกพฤติการณ์ที่ตาย</div>

            </b-col>

            <b-col lg="2" md="3">พฤติการณ์ที่ตาย 3</b-col>
            <b-col lg="10" md="9" style="padding-left: 0; padding-bottom: 0.5rem">
              <multiselect v-model="form.death_reason_addition3"
                           :options="optionCircumstances"
                           class="multiselect-style2"
                           deselect-label=""
                           label="name"
                           placeholder="เลือกพฤติการณ์ที่ตาย"
                           select-label=""
                           selectedLabel=""
                           track-by="id"
                           @input="updateForm('death_reason_addition3','id')"
              />
              <div v-if="msg_circumstances_id" class="error-message">กรุณาเลือกพฤติการณ์ที่ตาย</div>

            </b-col>

            <b-col lg="2" md="3">พฤติการณ์ที่ตาย 4</b-col>
            <b-col lg="10" md="9" style="padding-left: 0; padding-bottom: 0.5rem">
              <multiselect v-model="form.death_reason_addition4"
                           :options="optionCircumstances"
                           class="multiselect-style2"
                           deselect-label=""
                           label="name"
                           placeholder="เลือกพฤติการณ์ที่ตาย"
                           select-label=""
                           selectedLabel=""
                           track-by="id"
                           @input="updateForm('death_reason_addition4','id')"
              />
              <div v-if="msg_circumstances_id" class="error-message">กรุณาเลือกพฤติการณ์ที่ตาย</div>

            </b-col>

            <b-col lg="2" md="3">พฤติการณ์ที่ตาย 5</b-col>
            <b-col lg="10" md="9" style="padding-left: 0; padding-bottom: 0.5rem">
              <multiselect v-model="form.death_reason_addition5"
                           :options="optionCircumstances"
                           class="multiselect-style2"
                           deselect-label=""
                           label="name"
                           placeholder="เลือกพฤติการณ์ที่ตาย"
                           select-label=""
                           selectedLabel=""
                           track-by="id"
                           @input="updateForm('death_reason_addition5','id')"
              />
              <div v-if="msg_circumstances_id" class="error-message">กรุณาเลือกพฤติการณ์ที่ตาย</div>
            </b-col>

            <b-col lg="2" md="3">พฤติการณ์ที่ตายอื่นๆ</b-col>
            <b-col lg="10" md="9" style="padding-left: 0; padding-bottom: 0.5rem">
              <b-form-textarea id="textarea"
                               v-model="form.death_reason_addition_detail"
                               class="custom-input"
                               max-rows="6"
                               rows="3"
                               style="overflow-y: unset"
                               v-on:change="updateForm('death_reason_addition_detail')"
              >
              </b-form-textarea>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr>

      <!--ลักษณะ รายละเอียดผู้ตาย-->
      <b-row align="left">
        <b-col lg="12" style="padding-right: 0">10. รายละเอียดของศพ
          <a v-b-toggle.dead-detail-collapse class="radio-label" style="color: #2DA1A9">
            <b-icon icon="pencil-fill"></b-icon>
            กรอกข้อมูล</a>
        </b-col>
      </b-row>
      <b-collapse id="dead-detail-collapse">

        <b-row class="row">
          <b-col cols="12" lg="12" md="12" sm="12">
            <b-row align="left">
              <b-col class="pl-0" lg="12">
                <b-row>
                  <b-col lg="1" md="12" sm="12" style="padding-right: 0;">
                    <b-icon-circle-fill></b-icon-circle-fill>
                    รูปร่าง
                  </b-col>
                  <b-col style="font-weight: normal">
                    <b-form-radio-group id="radio-group-2" v-model="appearances.shape_id"
                                        @input="updateForm('shape_id',null,'appearance')">
                      <b-row>
                        <b-col cols="12" lg="12" md="12" sm="12">
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="1">อ้วนมาก</b-form-radio>
                          </label>
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="2">อ้วน</b-form-radio>
                          </label>
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="3">สมส่วน</b-form-radio>
                          </label>
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="4">ผอม</b-form-radio>
                          </label>
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="5">ผอมซูบ</b-form-radio>
                          </label>
                          <!--                                                <div class="error-message" v-if="msg_shape_id">กรุณาเลือกรูปร่าง</div>-->
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="d-inline mr-2"> ส่วนสูง</div>
                          <input v-model="appearances.height" class="d-inline custom-input"
                               maxlength="3"  max="250" min="30" style="width: 100px"
                                 onKeyPress="if(this.value.length==3) return false;" type="number" v-on:change="updateForm('height',null,'appearance')">
                          <div class="d-inline ml-2">ซม.</div>
                          <div v-if="msg_height" class="error-message text-left">กรุณากรอกส่วนสูงให้ถูกต้อง</div>
                        </b-col>
                      </b-row>
                    </b-form-radio-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row align="left">
              <b-col class="pl-0" lg="12">
                <b-row>
                  <b-col lg="1" md="12" sm="12" style="padding-right: 0;">
                    <b-icon-circle-fill></b-icon-circle-fill>
                    ผิวสี
                  </b-col>
                  <b-col style="font-weight: normal">
                    <b-form-radio-group id="radio-group-3" v-model="appearances.skin_color_id"
                                        @input="updateForm('skin_color_id',null,'appearance')">
                      <b-row>
                        <b-col cols="12" lg="12" md="12" sm="12">
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="1">ขาว</b-form-radio>
                          </label>
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="2">ขาวเหลือง</b-form-radio>
                          </label>
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="3">ดำแดง</b-form-radio>
                          </label>
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="4">ดำ</b-form-radio>
                          </label>
                          <!--                                                <div class="error-message" v-if="msg_shape_id">กรุณาเลือกรูปร่าง</div>-->
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" lg="12" md="12" sm="12" style="padding-left: 0">
                          <div class="d-inline col-sm-12 col-lg-4 col-md-6">
                            <label class="radio-label">
                              <b-form-radio value="5">อื่นๆ</b-form-radio>
                            </label>
                            <input v-if="appearances.skin_color_id == 5"
                                   v-model="appearances.skin_color_other"
                                   class="d-inline custom-input" style="width: 250px;"
                                   type="text" v-on:change="updateForm('skin_color_other',null,'appearance')">
                            <!--                                                    <div class="error-message" v-if="msg_skin_color_other">กรุณากรอกข้อมูล</div>-->
                          </div>
                        </b-col>
                      </b-row>
                    </b-form-radio-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row align="left">
              <b-col class="pl-0" lg="12">
                <b-row>
                  <b-col lg="1" md="12" sm="12" style="padding-right: 0">
                    <b-icon-circle-fill></b-icon-circle-fill>
                    เส้นผม
                  </b-col>
                  <!--                    <br v-if="msg_village_no"><span style="color: red;font-size: 10px" v-if="msg_village_no">กรุณากรอกข้อมูล</span><br v-if="msg_village_no">-->
                  <b-col style="font-weight: normal">
                    <b-form-radio-group id="radio-group-4" v-model="appearances.hair_style_id"
                                        @input="updateForm('hair_style_id',null,'appearance')">
                      <b-row>
                        <b-col cols="12" lg="12" md="12" sm="12">
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="1">สั้น</b-form-radio>
                          </label>
                          <label class="radio-label">
                            <b-form-radio class="radio-135" value="2">ยาว</b-form-radio>
                          </label>
                          <div v-if="msg_hair_style_id" class="error-message">กรุณาเลือกรูปร่าง</div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" lg="12" md="12" sm="12" style="padding-left: 0">
                          <div class="d-inline col-sm-12">
                            <div class="d-inline mr-2">สี</div>
                            <input v-model="appearances.hair_color"
                                   class="d-inline custom-input" style="width: 50%" type="text"
                                   v-on:change="updateForm('hair_color',null,'appearance')">
                          </div>
                          <!--                                                <div style="color: red;font-size: 10px;font-weight: normal;width: 100%;margin-left: 16em" v-if="msg_hair_color">กรุณากรอกข้อมูล</div>-->
                        </b-col>
                      </b-row>
                    </b-form-radio-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="row">
          <b-col cols="12" lg="12" md="12" sm="12">
            <b-row align="left" style="padding: 15px">
              <b-col lg="12" style="padding-right: 0">
                <b-icon-circle-fill></b-icon-circle-fill>
                เสื้อผ้าเครื่องแต่งกาย
              </b-col>
              <b-col class="mt-3" lg=12>
                <b-form-textarea id="textarea"
                                 v-model="appearances.cloth"
                                 class="custom-input"
                                 max-rows="6"
                                 rows="3"
                                 style="overflow-y: unset;"
                                 v-on:change="updateForm('cloth',null,'appearance')">
                </b-form-textarea>
                <!--                            <div class="error-message" v-if="msg_cloth">กรุณากรอกข้อมูล</div>-->
              </b-col>
            </b-row>
            <b-row align="left" style="padding: 15px">
              <b-col lg="12" style="padding-right: 0">
                <b-icon-circle-fill></b-icon-circle-fill>
                เครื่องประดับ
              </b-col>
              <b-col class="mt-3" lg=12>
                <b-form-textarea id="textarea"
                                 v-model="appearances.accessory"
                                 class="custom-input"
                                 max-rows="6"
                                 rows="3"
                                 style="overflow-y: unset"
                                 v-on:change="updateForm('accessory',null,'appearance')">
                </b-form-textarea>
                <!--                            <div class="error-message" v-if="msg_accessory">กรุณากรอกข้อมูล</div>-->
              </b-col>
            </b-row>
            <b-row align="left" style="padding: 15px">
              <b-col lg="12" style="padding-right: 0">
                <b-icon-circle-fill></b-icon-circle-fill>
                รอยสัก/ตำหนิ/แผลเป็น
              </b-col>
              <b-col class="mt-3" lg=12>
                <b-form-textarea id="textarea"
                                 v-model="appearances.defect"
                                 class="custom-input"
                                 max-rows="6"
                                 rows="3"
                                 style="overflow-y: unset;"
                                 v-on:change="updateForm('defect',null,'appearance')">
                </b-form-textarea>
                <!--                            <div class="error-message" v-if="msg_defect">กรุณากรอกข้อมูล</div>-->

              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-collapse>

      <!--end of form-->
      <b-col>
        <div align="center" cols="12" lg="4" md="4" sm="4">
          1/3
        </div>
      </b-col>
      <b-row>
        <b-col align="right" cols="6" lg="6" md="6" sm="6">
        </b-col>
        <b-col align="right" cols="6" lg="6" md="6" sm="6">
          <b-button class="autopsy-button" @click="goToNextPage"> หน้าถัดไป
            <b-icon icon="arrow-right-square"></b-icon>
          </b-button>
        </b-col>


      </b-row>
      <b-row>
        <b-col lg="4" md="4" sm="4"></b-col>
        <b-col lg="4" md="4" sm="4">
          <b-button class="autopsy-button" style="width:100%" @click="goToHomePage()">เสร็จสิ้น</b-button>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<style scoped>
span.mx-input-append::before, .mx-input-icon::before .mx-clear-icon::before {
  display: none !important;
}

span.mx-input-append, .mx-input-icon .mx-clear-icon {
  display: none !important;
}

span.mx-input-append::after, .mx-input-icon::after .mx-clear-icon::after {
  display: none !important;
}

@media only screen and (max-width: 499px) {
  .autopsy-button {
    font-size: 14px;
    /*width: 80%;*/
    /*margin: 20px 20px 5px 5px ;*/
  }
}

.bgType1 {
  background: #e6eeff;
}

.bgType2 {
  background: #fcdcc0;
}

/*#myIdUpload {*/
/*  font-family: Avenir, Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  text-align: center;*/
/*  color: #2c3e50;*/
/*  margin-top: 60px;*/
/*}*/
.form-frame {
  /*background: #F7F7F7;*/
  border-radius: 30px;
  font-size: 16px;
  color: #2DA1A9;
  font-weight: bold;
  padding: 1rem 0 2rem 0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}


.row {
  padding: 0.5rem 1rem 0 1rem;
}

.error-message {
  color: red;
  font-size: 10px;
  width: 100%;
  text-align: center;
  font-weight: normal;
}

.google-map {
  width: 100%;
  height: 420px;
  border: 3px solid #2DA1A9;
}


</style>

<script>
import {mapState} from "vuex";
import VueUploadMultipleImage from '../VueUploadMultipleImage.vue'
import CustomDatePicker from "../DatePicker";

export default {
  name: "form1",
  created() {
    this.prepare_form_data_page1();
  },
  mounted() {
    //Default of google map
    this.setDefaultLacation();
    //set number of form
    if (this.dataEventform) {
      this.case_id = this.dataEventform.case_id;
      this.event_id = this.dataEventform.event_id;
    }
  },
  data() {
    return {
      time_before_identify: '',
      nowDate: new Date().toISOString().slice(0, 10),
      status: '',
      SwitchData: true,
      center: {lat: 13.7563, lng: 100.5018},
      markers: [],
      places: [],
      show: true,
      currentPlace: [],
      msg: [],
      msg_event_id: false,
      msg_received_case_at: false,
      msg_departed_at: false,
      msg_arrived_at: false,
      msg_returned_at: false,
      // msg_response_officer_name:false,
      msg_police_station_id: false,
      // msg_doctor_name:false,
      msg_circumstances_id: false,
      msg_dead_name: false,
      // msg_dead_age:false,
      msg_dead_id: '',
      msg_address: false,
      msg_address_village_no: false,
      msg_address_street: false,
      msg_address_road: false,
      msg_village_no: false,
      msg_location_style: false,
      msg_short_history: false,
      msg_found_name: false,
      msg_treat_history: false,
      msg_dead_gender: false,
      msg_address_province_id: false,
      msg_address_district_id: false,
      msg_address_sub_district_id: false,
      msg_lat: false,
      msg_lng: false,
      msg_location_province_id: false,
      msg_location_district_id: false,
      // msg_location_sub_district_id:false,
      msg_found_at: false,
      msg_last_found_at: false,
      msg_location: false,
      msg_found_date: false,
      // msg_last_found_date:false,
      msg_death_reason_id: false,
      msg_death_reason_addition: false,
      //ส่วนที่ 10
      msg_shape_id: false,
      // msg_height: false,
      msg_skin_color_id: false,
      msg_skin_color_other: false,
      msg_hair_style_id: false,
      msg_hair_color: false,
      bangkok_location: {lat: 13.7563, lng: 100.5018},
      imgfor: '',
      checkedName: false,
      timeOfdead: false,
      checkedCurrentAddress: false,
      last_found_date: false,
      checkedCurrentAddressKnown: [],
      checkedCurrentAddressCheckbox: true,
      checkedAddressIDcard: false,
      checkedAddressFollowupIdCard: false,
      checkedMedicalHistory: false,
    }
  },
  computed: {
    ...mapState({
      username: state => state.Auth.username,
      user:state => state.Auth.users,
      optionProvince: state => {
        return state.Common.provinces;
      },
      optionDistrict: state => {
        return state.Common.districts;
      },
      optionSubDistrict: state => {
        return state.Common.sub_districts;
      },
      optionProvincedie: state => {
        return state.Common.provincesdie;
      },
      optionDistrictdie: state => {
        return state.Common.districtsdie;
      },
      optionSubDistrictdie: state => {
        return state.Common.sub_districtsdie;
      },
      optionDoctor: state => {
        return state.Hospital.listDoctor;
      },
      optionPolice: state => {
        return state.Police.police_station_for_hospital;
      },
      optionCircumstances: state => {
        return state.Circumstances.circumstances;
      },
      optionDeathreason: state => {
        return state.Deathreason.deathreason;
      },
      dataEventform: state => {
        return state.Eventform.createCase;
      },
      dataEditform: state => {
        return state.Eventform.case;
      },
      dataAPPEditform: state => {
        return state.Eventform.Appearances;
      },
      AllDistricts: state => {
        return state.Common.all_districts;
      },
      AllSubdistricts: state => {
        return state.Common.all_sub_districts;
      },
      form: state => {
        return state.Eventform.form;
      },
      appearances: state => {
        return state.Eventform.appearances;
      },
      images_case: state => {
        return state.Eventform.images_case;
      },
      images_card: state => {
        return state.Eventform.images_card;
      },
      images_dead_body: state => {
        return state.Eventform.images_dead_body;
      },
      computedClass() {
        let classStyle = this.form.event_type;
        if (classStyle == '1') {
          classStyle = "bgType1";
        } else if (classStyle == '2') {
          classStyle = "bgType2";
        }
        return classStyle;
      },
    }),
    //error message for missing or wrong value
    msg_location_sub_district_id: function () {
      return this.form.received_case_date == null || this.form.received_case_date == '';
    },
    err_msg_received_case_at: function () {

      return this.form.received_case_date == null || this.form.received_case_date == '';
    },
    err_msg_departed_at: function () {

      return (((this.form.departed_date == this.form.received_case_date) && (this.form.departed_at <= this.form.received_case_at)) || (this.form.departed_date < this.form.received_case_date));
    },
    err_msg_arrived_at: function () {

      return (((this.form.arrived_date == this.form.departed_date) && (this.form.arrived_at <= this.form.departed_at)) || (this.form.arrived_date < this.form.departed_date));
    },
    err_msg_returned_at: function () {

      return (((this.form.returned_date == this.form.arrived_date) && (this.form.returned_at <= this.form.arrived_at)) || (this.form.returned_date < this.form.arrived_date));
    },
    msg_last_found_date: function () {

      return (this.form.last_found_date > this.form.found_date) || ((this.form.last_found_date == this.form.found_date) && (this.form.last_found_at >= this.form.found_at));
    },
    msg_dead_age: function () {
      return (this.form.dead_age > 150);
    },
    msg_doctor_name: function () {
      return this.form.doctor_name!="" ? false : true;
    },
    msg_response_officer_name: function () {
      return this.form.response_officer_name ? false : true;
    },
    dead_address_in_IDCard: function () {
      if (
          this.form.dead_address_idCard || // ที่อยู่
          this.form.dead_place_address_idCard ||   // ที่อยู่(สถานที่)
          this.form.address_village_no_idCard ||     // หมู้บ้าน
          this.form.address_street_idCard ||         // ซอย
          this.form.address_road_idCard ||          // ถนน
          this.form.address_province_id_idCard ||   // จังหวัด
          this.form.address_district_id_idCard ||    // อำเภอ
          this.form.address_sub_district_id_idCard  // เขต
      ) {
        return true
      } else {
        return false

      }
    },
    msg_timeOfdead:function (){
      if(this.timeOfdead){
        this.setNullDeadDateTime();
        if ((!this.form.day_before_identify || this.form.day_before_identify==0) &&
            (!this.form.hours_before_identify || this.form.hours_before_identify == 0) &&
            (!this.form.minutes_before_identify || this.form.minutes_before_identify == 0)){
          return true;
        }else {
          return false;
        }

      }else {
        return false;
      }
    },
    msg_height:function (){
      return this.appearances.height >250;
    }
  },
  components: {
    VueUploadMultipleImage,
    CustomDatePicker
  },
  methods: {
    prepare_form_data_page1() {
      if (this.form.unknown_dead_name) {
        this.checkedName = true
      }
      if (this.form.unknown_dead_address) {
        this.checkedCurrentAddress = true
        console.log("this.form.unknown_dead_address", this.form.unknown_dead_address)
      } else {
        this.checkedCurrentAddress = false
      }
      if (this.form.unknown_dead_address_id) {
        this.checkedAddressIDcard = true
        console.log("this.form.unknown_dead_address_id", this.form.unknown_dead_address_id)
      } else {
        this.checkedAddressIDcard = false
      }
      console.log("this.user", this.user)

      this.getImage();
      this.$swal.close();
      this.$store.dispatch("Common/setProvince");
      this.$store.dispatch("Common/setProvincedie");
      this.$store.dispatch("Common/setAllDistricts");
      this.$store.dispatch("Common/setAllSubDistricts");
      this.$store.dispatch("Hospital/onGetListDoctor", this.user.hospcode);
      this.$store.dispatch("Police/onGetPoliceStationOption", this.user.hospcode);
      this.$store.dispatch("Circumstances/setCircumstances");
      this.$store.dispatch("Deathreason/setDeathreason");
      if (this.form.address_province_id != null) {
        this.getAddressDistricts(this.form.address_province_id);
      }
      if (this.form.address_district_id != null) {
        this.getAddresSubDistricts(this.form.address_district_id);
      }
      if (this.form.address_sub_district_id != null) {
        this.getAddressDistricts(this.form.address_sub_district_id);
      }
      if (this.form.address_province_id_idCard != null) {
        this.getAddressDistricts_Card(this.form.address_province_id_idCard);
      }
      if (this.form.address_district_id_idCard != null) {
        this.getAddresSubDistricts_Card(this.form.address_district_id_idCard);
      }
      if (this.form.address_sub_district_id_idCard != null) {
        this.getAddresSubDistricts(this.form.address_sub_district_id_idCard);
      }
      if (this.form.death_reason_id1 != null) {
        this.form.death_reason_id1 = this.setDeathReason(this.form.death_reason_id1)
      }
      if (this.form.death_reason_id2 != null) {
        this.form.death_reason_id2 = this.setDeathReason(this.form.death_reason_id2)
      }
      if (this.form.death_reason_id3 != null) {
        this.form.death_reason_id3 = this.setDeathReason(this.form.death_reason_id3)
      }
      if (this.form.death_reason_id4 != null) {
        this.form.death_reason_id4 = this.setDeathReason(this.form.death_reason_id4)
      }
      if (this.form.death_reason_addition1 != null) {
        this.form.death_reason_addition1 = this.setDeathReasonAddition(this.form.death_reason_addition1);
      }
      if (this.form.death_reason_addition2 != null) {
        this.form.death_reason_addition2 = this.setDeathReasonAddition(this.form.death_reason_addition2);
      }
      if (this.form.death_reason_addition3 != null) {
        this.form.death_reason_addition3 = this.setDeathReasonAddition(this.form.death_reason_addition3);
      }
      if (this.form.death_reason_addition4 != null) {
        this.form.death_reason_addition4 = this.setDeathReasonAddition(this.form.death_reason_addition4);
      }
      if (this.form.death_reason_addition5 != null) {
        this.form.death_reason_addition5 = this.setDeathReasonAddition(this.form.death_reason_addition5);
      }
      this.$store.dispatch("Eventform/onGetCaseSituation");
      this.$store.dispatch("Eventform/onGetCaseHospital");
      if (this.checkedAddressIDcard === true && this.checkedCurrentAddress === true) {
        this.checkedCurrentAddressKnown = "false";
      } else {
        this.checkedCurrentAddressKnown = "true";
      }
      if (this.form.doctor_name !=''){
        this.form.doctor_name = this.setDoctorName(this.form.doctor_name)

      }
    },
    dateUpdate(name, date) {
      this.form[name] = date;
      this.updateForm(name)
    },
    checkedUnknownInfomationOfDead(field_name) {
      let data = {}
      data['id'] = this.form.id;
      if (this.checkedCurrentAddressKnown !== 'true') {
        switch (field_name) {
          case 'unknown_dead_name':
            if (this.checkedName == true) {
              data[field_name] = 1;
            }
            break;
          case 'unknown_dead_address':
            if (this.checkedCurrentAddress == true) {
              data[field_name] = 1;
            }
            break;
          case 'unknown_dead_address_id':
            if (this.checkedAddressIDcard == true) {
              data[field_name] = 1;
            }
            break;
        }
      } else {
        data[field_name] = null;
      }

      this.$store.dispatch("Eventform/putCaseData", data)

    },
    setAddressFollowupIDcard() {
      if (this.checkedAddressFollowupIdCard) {
        let temp_province = this.form.address_province_id_idCard.code;
        let temp_district = this.form.address_district_id_idCard.district_id;
        let temp_sub_district = this.form.address_sub_district_id_idCard.subdistrict_id;

        this.form.dead_place_address = this.form.dead_place_address_idCard;
        this.form.address = this.form.dead_address_idCard;
        this.form.address_village_no = this.form.address_village_no_idCard;
        this.form.address_street = this.form.address_street_idCard;
        this.form.address_road = this.form.address_road_idCard;
        this.form.address_province_id = temp_province;
        this.form.address_district_id = temp_district;
        this.form.address_sub_district_id = temp_sub_district;

        let data = [
          {name: 'dead_place_address', value: this.form.dead_place_address},
          {name: 'address', value: this.form.dead_place_address},
          {name: 'address_village_no', value: this.form.address_village_no},
          {name: 'address_street', value: this.form.address_street},
          {name: 'address_road', value: this.form.address_road},
          {name: 'address_province_id', value: temp_province},
          {name: 'address_district_id', value: temp_district},
          {name: 'address_sub_district_id', value: temp_sub_district}
        ];
        data.forEach(item => {
          this.updateForm(item.name)
        });

        this.form.address_province_id = this.form.address_province_id_idCard;
        this.form.address_district_id = this.form.address_district_id_idCard;
        this.form.address_sub_district_id = this.form.address_sub_district_id_idCard;


      } else {
        this.form.dead_place_address = null;
        this.form.address = null;
        this.form.address_village_no = null;
        this.form.address_street = null;
        this.form.address_road = null;
        this.form.address_province_id = null;
        this.form.address_district_id = null;
        this.form.address_sub_district_id = null;
        let data = [
          {name: 'dead_place_address', value: this.form.dead_place_address},
          {name: 'address', value: this.form.dead_place_address},
          {name: 'address_village_no', value: this.form.address_village_no},
          {name: 'address_street', value: this.form.address_street},
          {name: 'address_road', value: this.form.address_road},
          {name: 'address_province_id', value: this.form.address_province_id},
          {name: 'address_district_id', value: this.form.address_district_id},
          {name: 'address_sub_district_id', value: this.form.address_sub_district_id}
        ];
        data.forEach(item => {
          this.updateForm(item.name)
        })
      }

    },
    async getDistricts(province) {
      await this.$store.dispatch('Common/setDistrict', province.code);
    },
    async getSubDistricts(district) {
      if (district) {
        await this.$store.dispatch('Common/setSubDistrict', district.district_id);
      }
    },
    async getAddressDistricts(province, isUpdate = false) {
      if (province) {
        await this.$store.dispatch('Common/setDistrictdie', province.code);
        if (isUpdate == true) {
          this.updateForm('address_province_id', 'code')
        }
      }
    },
    async getAddressDistricts_Card(province, isUpdate = false) {
      if (province) {
        await this.$store.dispatch('Common/setDistrictdie', province.code);
        if (isUpdate == true) {
          this.updateForm('address_province_id_idCard', 'code')
        }
      }
    },
    async getAddresSubDistricts(district, isUpdate = false) {
      if (district) {
        await this.$store.dispatch('Common/setSubDistrictdie', district.district_id);
        if (isUpdate == true) {
          this.updateForm('address_district_id', 'district_id')
        }
      }
    },
    async getAddresSubDistricts_Card(district, isUpdate = false) {
      if (district) {
        await this.$store.dispatch('Common/setSubDistrictdie', district.district_id);
        if (isUpdate == true) {
          this.updateForm('address_district_id_idCard', 'district_id')
        }
      }
    },

    setDefaultLacation: function () {
      if (this.form.lat == null) {
        this.form.lat = this.bangkok_location.lat;
        this.form.lon = this.bangkok_location.lng;
      }


      this.center = {lat: this.form.lat, lng: this.form.lon};
      this.markers = [];
      this.markers.push({position: this.center});
    },
    clearForm: function () {
      // this.$store.dispatch("Event/clearFormData");
    },
    checkForm: function () {
      if (this.form.event_id && this.form.case_id) {
        // this.$store.dispatch("Eventform/putCaseData",dataTableCase);
        this.goToNextPage()
      }
    },
    updateForm(field_name, child = null, table = null, val = null) {
      let tmp = this.form[field_name];
      if (field_name == "birthDate") {
        if (this.form.birthDate > this.nowDate || this.form.birthDate == null) {
          // this.$swal.fire({
          //   icon: 'error',
          //   title: 'ผิดพลาด',
          //   text: 'โปรดเลือก วัน/เดือน/ปี เกิด ให้ถูกต้อง',
          // })
          const Toast = this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          Toast.fire({
              icon: 'error',
              title: 'ผิดพลาด',
              text: 'โปรดเลือก วัน/เดือน/ปี เกิด ให้ถูกต้อง',
          })
          this.form.birthDate == null;
        } else {
          var dateSelect = new Date(this.form.birthDate);
          var dateNow = new Date().getFullYear();
          this.form.dead_age = dateNow - dateSelect.getFullYear();
        }
      }
      // if(field_name=="location_sub_district_id"){
      //   if (this.form.location_sub_district_id == null){
      //     this.$swal.fire({
      //       icon: 'error',
      //       title: 'ผิดพลาด',
      //       text: 'โปรดเลือก เขต/ตำบล',
      //     })
      //     this.form.location_sub_district_id == null
      //   }
      // }


      // console.log('field name XXXXXX', field_name, child, tmp)
      let value = null;
      let data = {};
      data['id'] = this.form.id;
      if (!table) {
        if (child) {
          value = this.form[field_name][child]
        } else {
          value = this.form[field_name]
        }
        data[field_name] = value;
        this.$store.dispatch("Eventform/putCaseData", data)


      } else if (table === 'appearance') {
        if (child) {
          value = this.appearances[field_name][child]
        } else {
          value = this.appearances[field_name]
        }
        data[field_name] = value;
        // console.log('set data',data.id,value, val)
        this.$store.dispatch("Eventform/putAppearancesData", data);


      }
      if (field_name == 'doctor_name' || field_name == 'response_officer_name') {
        this.setSignName();
      }
    },
    goToHomePage() {
      const path = `/home`
      if (this.$route.path !== path) this.$router.push(path)
    },
    // next form2
    goToNextPage() {
      let data = {
        id: this.form.id
      }
      this.$store.dispatch("Eventform/onGetCaseID", data);
      this.$store.dispatch("Eventform/onGetAppearancesID", data);
      this.$store.dispatch("Eventform/onGetTransformationID", data)
      const path = `/question-form/2`
      if (this.$route.path !== path) this.$router.push(path)
    },
    //method for google map
    //set ตำแหน่งของ marker
    getPosition(marker) {
      if (marker.position == undefined) {
        // Bangkok
        return {
          lat: 13.7563,
          lng: 100.5018
        }
      }
      return {
        lat: parseFloat(marker.position.lat),
        lng: parseFloat(marker.position.lng)
      }
    },
    toggleInfo() {
      this.infoOpened = true;
    },
    setLocation(marker) {
      this.markers = [];
      this.markers.push({position: marker});
      this.form.lat = marker.lat ? marker.lat : this.form.lat;
      this.form.lon = marker.lng ? marker.lng : this.form.lon;
      this.center = {lat: this.form.lat, lng: this.form.lon};
    },
    //set default place
    setPlace(place) {
      //"1839 Phahonyothin Rd, Khwaeng Lat Yao, Khet Chatuchak, Krung Thep Maha Nakhon 10900, Thailand"
      this.currentPlace = place;
      if (this.currentPlace) {
        this.form.location = place.name;
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.places.push(this.currentPlace.name);
        this.setLocation(marker);

      } else if (this.name) {
        this.places.push(this.name);

      }
    },
    geolocation() {
      this.SwitchData = true;
      navigator.geolocation.getCurrentPosition(pos => {
        var current = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude
        };
        var google_map_pos = new google.maps.LatLng(current.lat, current.lng);
        var self = this;
        /* Use Geocoder to get address */
        var google_maps_geocoder = new google.maps.Geocoder();
        google_maps_geocoder.geocode(
            {'latLng': google_map_pos},
            function (results, status) {
              if (status == google.maps.GeocoderStatus.OK && results[0]) {
                self.getAddress(results[0])
              }
            }
        );

        this.setLocation(current);
      }, err => {
        // console.log(err);
      });
    },
    setPlaceFromGoogleData(place) {
      // console.log('setPlaceNEW');
      let latLngtxt = place.latLng.toString()
      var setlatLng = latLngtxt.split(/[\s,()]+/)
      const marker = {
        lat: Number(setlatLng[1]),
        lng: Number(setlatLng[2])
      };

      var geocoder = new google.maps.Geocoder();
      var self = this;
      geocoder.geocode({'location': place.latLng, 'language': 'th'}, async function (results, status) {
        if (status === 'OK') {
          // console.log('results',results);
          self.form.location = results[0].formatted_address
          let province_key_name = 'administrative_area_level_1'
          let district_key_name = 'administrative_area_level_2'
          let sub_district_key_name = 'locality';
          console.log('sub_district_key_name', sub_district_key_name)
          const province = self.getAddressNameFromGoogleData(results[0], province_key_name, 'long_name').trim();

          console.log("province", province)


          // console.log('provincexxxxx',province)
          if (province == 'กรุงเทพมหานคร') {
            district_key_name = 'sublocality_level_1'
            sub_district_key_name = 'sublocality_level_2';
          }

          const district = self.getAddressNameFromGoogleData(results[0], district_key_name, 'long_name').trim();
          const sub_district = self.getAddressNameFromGoogleData(results[0], sub_district_key_name, 'long_name').trim();

          console.log("sub_district_key_name555555", sub_district)

          let selectedProvince = null
          let selectedDistrict = null
          let selectedSubDistrict = null
          // console.log(selectedProvince,selectedDistrict,selectedSubDistrict)
          for (const item of self.optionProvince) {
            if (item.name.trim() === province) {
              selectedProvince = item;
              // console.log("selectedProvince",selectedProvince)
              await self.getDistricts(selectedProvince);
              // console.log("await self.getDistricts(selectedProvince);",self.optionDistrict)
              break;
            }
          }

          if (selectedProvince != null) {
            for (const item of self.optionDistrict) {
              if (item.name.trim() === district) {
                selectedDistrict = item;
                await self.getSubDistricts(selectedDistrict)
                break;
              }
            }
          }
          if (selectedDistrict != null) {
            for (const item of self.optionSubDistrict) {
              if (item.name.trim().includes(sub_district)) {
                selectedSubDistrict = item;
                break;
              }
            }
          }
          // console.log(selectedProvince,selectedDistrict,selectedSubDistrict)

          console.log(selectedSubDistrict)

          self.form.location_province_id = selectedProvince
          self.form.location_district_id = selectedDistrict
          self.form.location_sub_district_id = selectedSubDistrict
          self.updateForm("location_province_id", 'code')
          self.updateForm("location_district_id", 'district_id')
          self.updateForm("location_sub_district_id", 'subdistrict_id')
          self.updateForm("lat")
          self.updateForm("lon")
          self.updateForm("location")
        }
      })
      this.setLocation(marker)
    },
    getAddressNameFromGoogleData(place, infoType, format) {
      let data = '';
      let addressComponents = [...place.address_components];


      for (const componentItem of addressComponents) {
        if (componentItem.types.find(type => type === infoType)) {
          data = componentItem[format];
          addressComponents.length = 0;
        }
      }
      // console.log(infoType,data)
      // console.log('datadatadata',data)

      let name = data.trim().replace('เขต', '')
          .replace('เขต ', '')
          .replace('แขวง', '')
          .replace('แขวง ', '')
          .replace('จ.', '')
          .replace('จังหวัด', '')
          .replace('อ.', '')
          .replace('ต.', '')
          .replace('อำเภอ', '')
          .replace('ตำบล', '');

      return name;
    },

    //method about image
    uploadImageSuccess(formData, index, fileList, mode) {
      let data = {
        id: this.form.id,
        formData: formData,
        index: index,
        name: fileList[index].name,
        path: fileList[index].path,
        case_id: this.form.case_id,
        mode: mode
      }

      // console.log("fileList",fileList)
      // Upload image api
      this.$store.dispatch("Eventform/onUploadImg", data);


    },
    beforeRemove(index, done, fileList, mode) {
      let data = {
        id: this.form.id,
        index: index,
        name: '',
        path: fileList[index].path,
        case_id: this.form.case_id,
        mode: mode
      }
      if (mode == 'case') {
        data.name = this.images_case[index].path
      } else if (mode == 'card') {
        data.name = this.images_card[index].path
      } else if (mode == 'deadBody') {
        data.name = this.images_dead_body[index].path
      }

      this.$confirm(
          {
            message: `โปรดยืนยันการลบรายการ`,
            button: {
              no: 'ยกเลิก',
              yes: 'ยืนยัน'
            },
            /**
             * Callback Function
             * @param {Boolean} confirm
             */
            callback: confirm => {
              if (confirm) {
                if (data.mode == 'case') {
                  this.$store.dispatch("Eventform/onDeleteCaseImg", data).then(() => {
                    // console.log("finish delete", this.images_case)
                  });
                } else if (data.mode == 'card') {
                  this.$store.dispatch("Eventform/onDeleteCardImg", data).then(() => {
                    // console.log("finish delete", this.images_card)
                  });
                } else if (data.mode == 'deadBody') {
                  this.$store.dispatch("Eventform/onDeleteDeadBodyImg", data).then(() => {
                    // console.log("finish delete", this.images_dead_body)
                  });
                }
              }
            }
          }
      )
    },
    getImage() {
      let data = {
        id: this.form.id,
        case_id: this.form.case_id,
      }
      this.$store.dispatch("Eventform/onGetCaseImg", data)
      this.$store.dispatch("Eventform/onGetCardImg", data)
      this.$store.dispatch("Eventform/onGetDeadBodyImg", data)

      // console.log("data",data)
    },
    //check format of citizenID
    checkCitizenIDformat(event) {
      let val = event.target.value.trim()
      if (/^[1-9]\d*$|^$/.test(val)) {
        if ((val.length) === 13) {
          setTimeout(() => {
            var total = 0;
            var chk;
            var Validchk = val.substr(12, 1);
            var j = 0;
            var pidcut;
            for (var n = 0; n < 12; n++) {
              pidcut = parseInt(val.substr(j, 1));
              total = (total + ((pidcut) * (13 - n)));
              j++;
            }
            chk = 11 - (total % 11);
            if (chk == 10) {
              chk = 0;
            } else if (chk == 11) {
              chk = 1;
            }
            if (chk == Validchk) {
              // alert("ระบุหมายเลขประจำตัวประชาชนถูกต้อง");
              this.msg_dead_id = null;
              this.updateForm('dead_id')
              return this.dead_id = val;
            } else {
              // alert("ระบุหมายเลขประจำตัวประชาชนไม่ถูกต้อง");
              this.msg_dead_id = 'ระบุหมายเลขประจำตัวประชาชนไม่ถูกต้อง';
              return this.dead_id = null;
            }
            // this.this.dead_id = val;
          }, 1500)
        }
      } else {
        // event.target.value = this.dead_id;
        this.msg_dead_id = 'ระบุหมายเลขประจำตัวประชาชนไม่ถูกต้อง ต้องเป็นตัวเลข13หลัก';
        return this.dead_id = null;
      }
    },
    setAddress() {
      this.checkedAddressIDcard = true; //  unknown_dead_address_id
      this.checkedCurrentAddress = true; //  unknown_dead_address
    },
    setNullDeadDateTime() {
      this.form.dead_date = null;
      this.form.dead_time = null;
      this.updateForm('dead_date');
      this.updateForm('dead_time');
    },
    gotoSetting() {
      const path = `/settingListPoliceStation`
      if (this.$route.path !== path) this.$router.push(path)
    },
    setDeathReasonAddition(id) {
      let temp_data = this.optionCircumstances.filter(item => {
        return item.id == id;
      });
      return temp_data;
    },
    setDeathReason(id) {
      let temp_data = this.optionDeathreason.filter(item => {
        return item.id == id;
      });
      return temp_data;
    },
    setSignName() {
      if (this.form.doctor_name) {
        this.form.sign_doctor_name = this.form.doctor_name.name
        this.updateForm('sign_doctor_name');
      }
      if (this.form.response_officer_name) {
        this.form.officer_name = this.form.response_officer_name
        this.updateForm('officer_name');
      }
    },
    setDoctorName(name) {
      console.log("name",name)
      let temp_data = this.optionDoctor.filter(item => {
        return item.name === name;
      });
      return temp_data[0];
    },
  }
}
</script>


